export const SCROLL_TO_CLASS = 'retirmentCalculator/scrolling/transition/scrollToClass';
export const SCROLL_TO_ID = 'retirmentCalculator/scrolling/transition/scrollToId';
export const CLEAR_SCROLL = 'retirmentCalculator/scrolling/transition/resetScroll';

export const transitionScrolling = {
    scrollToClass: (value) => ({type: SCROLL_TO_CLASS, value}),
    scrollToId: (value) => ({type: SCROLL_TO_ID, value}),
}

export const resetScroll = () => ({ type: CLEAR_SCROLL });
